import * as React from "react";
const SvgFiRrPlusHexagon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-plus-hexagon_svg__a)">
      <path
        fill="#062147"
        d="m23.34 9.481-3.5-6A5.02 5.02 0 0 0 15.521 1H8.452a5.02 5.02 0 0 0-4.319 2.481l-3.5 6a5.01 5.01 0 0 0 0 5.038l3.5 6a5.02 5.02 0 0 0 4.318 2.48h7.07c1.77 0 3.425-.95 4.318-2.48l3.5-6.001a5.01 5.01 0 0 0 0-5.038zm-1.729 4.031-3.499 6A3.01 3.01 0 0 1 15.52 21H8.451a3.01 3.01 0 0 1-2.59-1.488l-3.5-5.999a3 3 0 0 1 0-3.024l3.5-6A3.01 3.01 0 0 1 8.45 3h7.07c1.061 0 2.055.57 2.59 1.489l3.5 6a3 3 0 0 1 0 3.023M17.001 12a1 1 0 0 1-1 1h-3v3a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8a1 1 0 1 1 2 0v3h3a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-plus-hexagon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPlusHexagon;
